import { safeSessionStorage } from './safeStorage';

export default () => {
	const timestamp = Date.now();
	const clickPathFromSessionStorage = safeSessionStorage.getItem(
		'ws-tracking-clickpath'
	);
	let clickPath;

	// this check is temporary while we roll this out from being stored as an object
	if (clickPathFromSessionStorage?.startsWith('{')) {
		const clickPathObject = JSON.parse(clickPathFromSessionStorage);
		clickPath = Object.values(clickPathObject).map((value) => value);
	} else {
		clickPath = JSON.parse(
			safeSessionStorage.getItem('ws-tracking-clickpath') || '[]'
		);
	}

	const uuid = window.DDC.dataLayer.vehicles[0]?.uuid;
	const { isVdp } = window.DDC.dataLayer.page.pageInfo;
	clickPath.push({
		path: window.location.href,
		viewType: 'page',
		timestamp
	});
	if (isVdp && uuid) {
		clickPath.push({
			path: uuid,
			viewType: 'vdp',
			timestamp
		});
	}
	safeSessionStorage.setItem(
		'ws-tracking-clickpath',
		JSON.stringify(clickPath)
	);
};
